/**
 * Placeholder data for the parts of the Work Order drilldown that have no
 * endpoint yet — Document Versions and Logs — plus the empty shape the detail
 * screen renders before `GET /work-order/detail` resolves.
 *
 * Project Information, its routing tables and the Comments tab now read the
 * work-order and workflow services; only what is left below is still mocked.
 */

export interface WorkOrderDetail {
  workOrderNo: string;
  projectTitle: string;
  status: string;
  requesterName: string;
  requesterEmail: string;
  dateRequest: string;
  jobTitle: string;
  subsidiary: string;
  costCentre: string;
  department: string;
  prNo: string;
  commencementDate: string;
  completionDate: string;
  category: string;
  region: string;
  subRegion: string;
  procurementApproach: string;
  vendor: string;
  documentName: string;
  documentLink: string;
}

export const workOrderDetail: WorkOrderDetail = {
  workOrderNo: "000001",
  projectTitle: "Employee App project",
  status: "created",
  requesterName: "John Doe",
  requesterEmail: "Johndoe@gmail.com",
  dateRequest: "07-Oct-2025",
  jobTitle: "Lorem Ipsum",
  subsidiary: "UTW-Research & Innovation",
  costCentre: "UTW-Research & Innovation",
  department: "Lorem Ipsum",
  prNo: "12",
  commencementDate: "07-Oct-2025",
  completionDate: "07-Oct-2025",
  category: "Lorem Ipsum",
  region: "Lorem Ipsum",
  subRegion: "Lorem Ipsum",
  procurementApproach: "Emergency",
  vendor: "Lorem Ipsum",
  documentName: "-",
  documentLink: "-",
};
